export const bodyEmail = `Gentile cliente,



Sono lieto di condividere un'analisi dettagliata del vostro portafoglio di investimenti.



In allegato trovate il report completo del portafoglio che include:

- Panoramica del portafoglio
- Analisi della distribuzione per asset class
- Valutazione del rischio e del rendimento
- Analisi basata sui dati di backtest


Cordiali saluti,`;
